import React from 'react';
import { Users } from 'lucide-react';
import { ConsultantsGallery } from './consultants/ConsultantsGallery';

export const ConsultantsPage: React.FC = () => {
  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
          <Users className="w-8 h-8 text-purple-300" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-purple-200">Consultores</h2>
          <p className="text-purple-300/70">Encontre o especialista ideal para sua jornada</p>
        </div>
      </div>

      <ConsultantsGallery />
    </div>
  );
};